'use strict';

var Widgets = {};

Widgets.AjaxFormInPlaceTransition = require('./AjaxFormInPlaceTransition');
Widgets.BootstrapAccordion = require('./BootstrapAccordion');
Widgets.Chart = require('./Chart');
Widgets.CheckableItemsList = require('./CheckableItemsList');
Widgets.CheckableRowsTable = require('./CheckableRowsTable');
Widgets.ColumnSelector = require('./ColumnSelector');
Widgets.DetailsToggleWidget = require('./DetailsToggleWidget');
Widgets.ElementSpecificMessage = require('./ElementSpecificMessage');
Widgets.FadeOutModal = require('./FadeOutModal');
Widgets.HighlightableRowsTable = require('./HighlightableRowsTable');
Widgets.MessageModal = require('./MessageModal');
Widgets.OrderableItemList = require('./OrderableItemList');
Widgets.ProgressBar = require('./ProgressBar');
Widgets.SimpleLoadingMessage = require('./SimpleLoadingMessage');
Widgets.ValuesList = require('./ValuesList');
Widgets.WidgetUtils = require('./WidgetUtils');
Widgets.Modal = require('./Modal');
Widgets.ModalManager = require('./ModalManager');

module.exports = Widgets;


//////////////////
// WEBPACK FOOTER
// ./mits/Widgets/index.js
// module id = 41
// module chunks = 0